<template>
  <div class="rc-ocr">
    <label class="item-name"><i class="required" v-show="initComponent.properties.required">*</i>{{initComponent.name}}</label>
    <div class="component-content">
      <el-button type="text"  :class="{'readonly': component.properties.readonly}" ><u>请选择</u></el-button>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-ocr',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>

<style lang="scss">
  .rc-ocr {
    .readonly {
      color: #2A2929;
      u {
        text-decoration: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/ocr/rc-ocr.vue